import { render } from "./ProfileSuccess.vue?vue&type=template&id=12e3817c&scoped=true"
import script from "./ProfileSuccess.vue?vue&type=script&lang=js"
export * from "./ProfileSuccess.vue?vue&type=script&lang=js"

import "./ProfileSuccess.vue?vue&type=style&index=0&id=12e3817c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e3817c"]])

export default __exports__